import * as actionTypes from '../../constants/ActionTypes/Dashboard';

const initialState = {
    myAccount:{},
    loading: false,
    error: false,
    success: false
  }

const FetchMyAccount = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_MY_ACCOUNT:
            return {
                ...state,
                loading: true,
                success: false
            }
        
        case actionTypes.FETCH_MY_ACCOUNT_SUCCESS:
            return {
                ...state,
                myAccount: action.myAccount,
                loading: false,
                success: true
            }
        
        case actionTypes.FETCH_MY_ACCOUNT_ERROR:
            return {
                ...state,
                loading: false,
                error: action.message,
                success: false
            }

        case actionTypes.FETCH_MY_ACCOUNT_RESET:
            return {
                ...state,
                loading: false,
                error: false,
                success: false,
                myAccount:{}
            }
        default:
            return {...state}
    }
}

export default FetchMyAccount